import React, { useState } from "react";
import { authFetch } from "../utils/authFetch";
import { useEffect } from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import GeneralCustomerOffer from "../offers/GeneralCustomerOffer";
import RaportManoperaProd from "./RaportManoperaProd";
import RaportNecesarAprov from "./RaportNecesarAprovizionare";
import RaportConsumReteta from "./RaportConsumProd";

export default function RapoarteProductie() {
  const [simaus,setSimaus] = useState(false);
  const [key, setKey] = useState("manopera");

  useEffect(() => {
    let active=true;
    authFetch("/company-modules").then(r=>{if(active)setSimaus(r.app_variant === "SIMAUS");}).catch(()=>{});
    return ()=>{active=false;};
  }, []);

  useEffect(() => {
    // Asigură-te că tabelele de producție există
    authFetch("/comenzi-prod/setup-db").catch(console.error);
  }, []);


  return (
    <Container fluid className="py-3">
      <h3 className="mb-4">Rapoarte Producție</h3>
      <Tabs
        id="rapoarte-productie-tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-4"
      >
        <Tab eventKey="manopera" title="Pontaj / Manoperă Angajați">
          <RaportManoperaProd />
        </Tab>
        <Tab eventKey="necesar" title="Necesar Aprovizionare">
          <RaportNecesarAprov />
        </Tab>
        <Tab eventKey="consum" title="Rețetă și materiale transferate">
          <RaportConsumReteta />
        </Tab>
        {simaus && <Tab eventKey="general-offer" title="Ofertă generală pe client" mountOnEnter unmountOnExit><GeneralCustomerOffer /></Tab>}
      </Tabs>
    </Container>
  );
}
